import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import TicketingNew from ".";

const TicketingNewModal = ({ isOpen, toggle, reloadTickets }) => {
  return (
    <div>
      <Modal toggle={toggle} isOpen={isOpen} style={{ fontFamily: "Nunito" }} size="lg" backdrop="static">
        <ModalHeader className="border-0 pb-0" toggle={toggle} />
        <ModalBody>
          <TicketingNew toggle={toggle} reloadTickets={reloadTickets} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default TicketingNewModal;
